export default {"src":"/_next/static/image/public/images/icons1/1.351cfc47d8044e023f2982efeb70efa4.svg","height":19,"width":16};